export const ScheduleCategories = [
  {
    type: "equipment_schedule",
    categories: [
      "Equipment",
      "Blowers",
      "AW Blowers",
      "Axial Blower Fan",
      "Centrifugal Blower",
      "General Blower",
      "Compressors",
      "Conveyors",
      "Crushers",
      "Driers",
      "Energy Symbols",
      "Filters",
      "Furnances",
      "Heat Exchnagers",
      "Mechanical Drivers",
      "AW Motors / Drivers",
      "Air Motor",
      "Electric Motor - Fixed Speed",
      "Electric Motor - Variable Speed",
      "Gearbox",
      "Integrated Fan",
      "Reciprocating Engine",
      "Miscellaneous Equipment",
      "Mixing Equipment",
      "Nuclear Reactors",
      "Pumps",
      "AW Pumps & Compressors",
      "Archimedean Screw Pump",
      "Archimedean Screw Tank Reciruclation Pump",
      "Axial Blow Fan",
      "Carboy Pump",
      "Centrifugal Axial Flow Compressor",
      "Metering Pump",
      "Positive Displacement - Progressive Cavity Pump",
      "Positive Displacement - Screw Pump",
      "Progressive Cavity Macerator Pump",
      "Reciporcating Pump",
      "Rotary Pump - Centrifugal",
      "Rotary Pump - General",
      "Rotary Pump - Grinder",
      "Rotary Pump - Lobe",
      "Rotary Pump - Positive Displacement",
      "Rotary Pump - Submersible",
      "Rotary Pump - Submersible Grinder",
      "Two Stage Reciprocating Compressor",
      "Tanks",
      "AWTankVessels",
      "Air Reveiver / Drum",
      "Closed Tank With Sealed Manway",
      "Closed Tank With Vent",
      "Covered Tank",
      "Degassing Tower",
      "Dessicant Drier",
      "Detritor",
      "Digestor",
      "Dorr Type Detritor",
      "Floating Draw Off Arm",
      "Gas Holder",
      "Lamella Hopper",
      "Open Tank",
      "Saturator",
      "Settlement Tank Conical Bottom",
      "Settlement Tank Flat Bottom",
      "Skip / Bin",
      "Storage Hopper / Silo",
      "Storage Hopper / Silo With Vibrator",
      "Storage Tank",
      "AWTankBridges",
      "AWClarifiers",
      "AWAeration",
      "AWTankThickeners",
    ],
  },
  {
    type: "pipeline_schedule",
    categories: ["Dual Contained Pipeline", "Major Pipeline", "Minor Pipeline"],
  },
  {
    type: "pressure_test_schedule",
    categories: ["Dual Contained Pipeline", "Major Pipeline", "Minor Pipeline"],
  },
  {
    type: "instrument_schedule",
    categories: [
      "AW Flow Measurement",
      "Flow - Electromagnetic",
      "Flow - Flow Nozzle",
      "Flow - General",
      "Flow - Orifice Plate",
      "Flow  - Pitot Tube",
      "Flow - Rotary Displacement",
      "Flow - Sight Glass",
      "Flow - Turbine / Rotary",
      "Flow - Variable Are",
      "Flow - Venturi Tube",
      "AW General Measurement",
      "General Instrument",
      "General Instrument Mechanical Indicator",
      "AW Level Measurement",
      "Level - Displacer",
      "Level - Electrode Capacitive",
      "Level - Electrode Conductive",
      "Level - Float",
      "Level - General",
      "Level - Membrane Diaphragm",
      "Level - Resistance Strain Guage",
      "Level - Sight Glass Tank Level",
      "Level - Ultrasonic",
      "AW Pressure Measurement",
      "Pressure - Differential",
      "Pressure - General",
      "Pressure - Mechanical Indicator",
      "AW Quality Meaurement",
      "Quality - Acidity",
      "Quality - Ammonia",
      "Quality - Conductivity",
      "Quality - Dissolved Oxygen",
      "Quality - Free Chlorine",
      "Qulaity - General",
      "Quality - Iron",
      "Quality - Nitrates",
      "Quality - Phosphates",
      "Quality - Suspended Solids",
      "Quality - Total Chlorine",
      "Quality - Turbidity",
      "Quality - Ultra Violet Tranmissivity",
      "AW Temperature Measurement",
      "Temperature - General",
      "Temperature - Mechanical Indicator",
    ],
  },
  {
    type: "valve_schedule",
    categories: [
      "Hand Valves",
      "AW Hand Valves",
      "3-Way Plug Valve - L Port",
      "3-Way Plug Valve - T Port",
      "3-Way Valve - L Port",
      "3-Way Valve - T Port",
      "Air Release Valve",
      "Ball Valve",
      "Butterfly Valve",
      "Condensanate Release Valve",
      "Diaphragm Valve",
      "Double Non-Return Valve",
      "Flap Valve",
      "Flow Restrictor - Fixed",
      "Flow Restrictor - Variable",
      "Gate Valve",
      "General Valve",
      "Globe Valve",
      "Hyrdant Valve",
      "Needle Valve",
      "Non-Return Valve",
      "Parrallel Slide Valve",
      "Pinch Valve",
      "Plug Valve",
      "Ported Sleeve Valve",
      "Pressure Loading Valve",
      "Pressure Reducing Valve",
      "Rotary Feeder Valve",
    ],
  },
];

//Formula to be used in excel
//=""""&A11&""""&","
//=D11
//=G11&D12
